import axios from "axios";
import {Message} from "element-ui";
import store from "@/store";

console.log(process.env.VUE_APP_LOCAL_URL)
const request = axios.create({
 baseURL: process.env.VUE_APP_LOCAL_URL,
 headers: {
     'Content-Type': 'application/json;charset=UTF-8'
   },
 timeout: 10000
})

// 请求拦截
request.interceptors.request.use(config => {

 if (store.getters.getToken) config.headers['token'] = store.getters.getToken

 return config
})

// 相应拦截
request.interceptors.response.use(response => {
 const {code} = response.data

 switch (code) {
  case 1:
   return Promise.resolve(response.data)
  case 0:
   Message.error(response.data.msg)
   return Promise.reject('error: ' + response.data.code)
  case 4000:
   Message.error(response.data.msg)
   return Promise.reject('error: ' + response.data.code)
  default:
   return Promise.reject('error: ' + response.data.code)
 }
}, error => {
 Message.error('服务器错误，请找管理员！')
 return Promise.reject(error)
})

export default request